<template>
<class-sidebar
    showToggle
    v-model="expanded"
    class="nch-sidebar-nav"
>
    <template #header>
        <div class="list-group-item">
            <div class="progress-circle">
                <div class="skill">
                    <div class="outer">
                        <div class="inner">
                            <div id="number">
                                {{ courseProgress }}%
                            </div>
                        </div>
                    </div>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        version="1.1" width="120"
                        height="120">
                            <defs>
                                <linearGradient
                                id="GradientColor">
                                    <stop offset="0%" stop-
                                    color="#DA22FF" />
                                    <stop offset="100%" stop-
                                    color="#9733EE" />
                                </linearGradient>
                            </defs>
                        <circle :style="`--course-progress: ${courseProgress}`" cx="57" cy="59" r="47"
                        stroke-linecap="round" />
                    </svg>
                </div>
            </div>
            <slot name="title">
                <h4
                    :title="course.translation && course.translation.name"
                    style="font-size: 22px;"
                    class="mb-0"
                >
                    {{ $trim(course.translation && course.translation.name, 35) }}
                </h4>
            </slot>
            <div v-if="hasIconButtons" class="icons-container">
                <i
                    v-if="!!course.translation?course.translation.description:false"
                    @click="openModal('description')"
                    class="mdi mdi-information"
                />
                <i
                    v-if="forum"
                    @click="openModal('forum')"
                    class="mdi mdi-forum"
                />
                <i
                    v-if="generateCertificate"
                    @click="goToCertificate"
                    class="mdi mdi-trophy"
                />
            </div>
            <BaseButton
                @click="expanded = !expanded"
                class="btn-icon-only rounded-circle"
                outline
                type="secondary"
            >
                <i class="mdi mdi-24px mdi-chevron-left" />
            </BaseButton>
        </div>
        <span
            v-if="this.menuItems.length === 0"
            class="text-center course-without-content"
        >
            {{$t('course.course_no_content')}}
        </span>
    </template>
    <class-menu-content
        v-for="item in menuItems"
        :key="item.content_id"
        :childLevel="0"
        :item="item"
        :lastContent="lastContent"
    />
</class-sidebar>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Collapse from '../../argon/components/Collapse/Collapse';
import CollapseItem from '../../argon/components/Collapse/CollapseItem';
import BaseButton from '../../argon/components/BaseButton';

import Topic from '../Common/TopicComponents/Topic';
import ClassMenuContent from './ClassMenuContent';
import ClassSidebar from './ClassSidebar';

export default {
    emits: ['input', 'update:modelValue'],
    name: 'ClassMenu',

    components: {
        ClassSidebar,
        Collapse,
        CollapseItem,
        Topic,
        ClassMenuContent,
        BaseButton,
    },

    props: {
        modelValue: Boolean,
        certificate: Object,
        forum: Number,
        lastContent: {
            type: String,
            required: true,
        },
    },

    computed: {
        ...mapGetters({
            course: 'CLASS_COURSE',
            menuItems: 'CLASS_MENU_ITEMS',
        }),
        hasIconButtons() {
            return this.course.translation?.description || this.forum || this.certificate;
        },
        expanded: {
            get() { return this.modelValue; },
            set(value) { this.$emit('update:modelValue', value); },
        },
        generateCertificate() {
            var generateCertificate
                = this.course.progress_value >= this.course.certificateProgress;
            return generateCertificate ? true : false;
        },
        courseProgress() {
            return this.course.progress_value;
        },
    },

    methods: {
        ...mapActions({
            loadForum: 'CLASS_LOAD_FORUM',
        }),
        ...mapMutations({
            setModal: 'SET_CLASS_MODAL',
        }),
        async openModal(tab) {
            await this.setModal({
                tab,
                open: true,
                id: this.course.id,
                type: 'course',
                description: this.course.translation?.description,
                name: this.course.translation?.name,
            });
            if (tab === 'forum') {
                this.loadForum();
            }
        },
        async goToCertificate() {
            if (!this.generateCertificate) {
                return this.$notify({
                    type: 'warning',
                    message: this.$t('class.certificate_without_progress'),
                });
            }
            window.location = `/app/certificate/show/course/${this.course.id}`;
        },
    },
};
</script>

<style lang="sass" scoped>
.list-group-item
    border-radius: 0
    display: flex
    justify-content: space-between
    align-items: center
    border-bottom: 3px solid #5e72e4 !important

.rounded-circle
    width: 3rem !important
    height: 3rem !important
    cursor: pointer
    display: grid
    place-items: center

.side-bar-text
    font-size: 0.8rem

.icons-container
    display: flex
    background-color: #fff
    padding: 8px
    gap: 10px
    i
        font-size: 20px
        color: black
        cursor: pointer

.progress-circle
    background-color: #fff
    display: flex
    align-items: center
    justify-content: center
    margin-right: 20px

@media screen and (max-width: 1027px)
    .progress-circle
        display: none

.skill
    width: 100px
    height: 100px
    position: relative

.outer
    height: 100px
    width: 100px
    padding: 20px
    border-radius: 50%

.inner
    height: 75px
    width: 75px
    border-radius: 50%
    display: flex
    align-items: center
    justify-content: center

#number
    font-weight: 600
    color: #5e72e4

circle
    fill: none
    stroke: #5e72e4
    stroke-width: 5
    stroke-dasharray: 300
    stroke-dashoffset: 300
    animation: anim 2s linear forwards

@keyframes anim
    from
        stroke-dashoffset: 300
    to
        stroke-dashoffset: calc(300 - 300 * (var(--course-progress) / 100))

svg
    position: absolute
    top: 0
    left: 0

.v-tooltip__content
    background: #616161
    border-radius: 2px
    color: #fff
    font-size: 12px
    display: inline-block
    padding: 5px 8px
    position: absolute !important
    text-transform: none
    width: auto
    box-shadow: 0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)

.v-tooltip__content[class*=-active]
    transition: .15s cubic-bezier(.25,.8,.5,1)
    pointer-events: none

.v-tooltip__content--fixed
    position: fixed

.custom-tooltip
    width: 80%
    top: 100px !important
    opacity: 1 !important
</style>

<style scoped lang="scss">
@media (max-width: 1027px)
{
    .nch-sidebar-nav{
        position: absolute;
        max-width: 300px;
        width: 100%;
        z-index: 75;
        left: 0;
        height: -webkit-fill-available;
    }
    .course-without-content {
        margin-top: 20px;
    }
}
</style>
